import * as React from 'react'

const HomeIcon = ({ foreground }: { foreground: React.SVGProps<SVGPathElement>['fill'] }) => (
  <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 60">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M32.2 34.31a1.1 1.1 0 00-1.1-1.1h-2.2a1.1 1.1 0 00-1.1 1.1v3.436a1.1 1.1 0 01-1.1 1.1h-4.4a1.1 1.1 0 01-1.1-1.1v-6.875a1.1 1.1 0 01.422-.866l8.039-6.293a.55.55 0 01.678 0l8.04 6.293a1.1 1.1 0 01.421.866v6.875a1.1 1.1 0 01-1.1 1.1h-4.4a1.1 1.1 0 01-1.1-1.1V34.31z"
      fill={foreground}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19 26.174c0-.334.152-.65.413-.859l10.243-8.195a.55.55 0 01.688 0l10.243 8.195a1.1 1.1 0 01.413.86v2.22a.55.55 0 01-.88.44l-9.79-7.342a.55.55 0 00-.66 0l-9.79 7.343a.55.55 0 01-.88-.44v-2.222z"
      fill={foreground}
    />
  </svg>
)

export default HomeIcon
